import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
// import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SeatMapService } from 'src/app/services/seat-map.service';
import { TicketsService } from 'src/app/services/tickets.service';
import { NameMapComponent } from '../name-map/name-map.component';
import { EventosService } from 'src/app/services/eventos.service';
import { PlacesService } from 'src/app/services/places.service';
import { GenerateMapService } from 'src/app/services/generate-map.service';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ApiSalesService } from 'src/app/services/api-sales.service';


@Component({
  selector: 'app-create-map',
  templateUrl: './create-map.component.html',
  styleUrls: ['./create-map.component.scss']
})
export class CreateMapComponent implements OnInit, OnDestroy, OnChanges {
  isSuperAdmin: boolean = false;

  @Input() fromVenue!: boolean;
  @Input() fromEvent!: boolean;
  @Input() fromCreate!: boolean;
  @Input() idMap!: number;
  @Input() map!: any;
  @Input() idEvent!: number;
  @Input() idSpace!: number;
  @Input() allowCreate: boolean = false;
  @Input() venue!: any;
  loading: boolean = true;
  loadingCanvas: boolean = true;
  titleMap!: any;
  editEvent: boolean = false;
  bookingSeats!: any;
  mapSaved!: any;
  @Output() save = new EventEmitter<any>();
  // Permite a componentes padre (p.ej. app-map-seats-create) mostrar su propio
  // spinner mientras se cargan los datos del mapa y se pinta el canvas.
  @Output() loadingChange = new EventEmitter<boolean>();
  @Input() isSaving: boolean = false;
  capacity!: number;

  private emitLoadingState(): void {
    this.loadingChange.emit(this.loading || this.loadingCanvas);
  }

  // BlockedSeats
  @Input() blockedSeats: any[] = [];
  @Input() selectedSession!: number;

  // Pedido al que pertenece cada butaca ocupada (indexado por id_seat). Solo se
  // carga al editar un evento (fromEvent) para mostrarlo al hacer hover en el mapa.
  seatsOrders: { [id: number]: any } = {};
  // Mapa id_channel → nombre del canal (mismos nombres que usa el detalle de pedido).
  channelsMap: { [id: number]: string } = {};

  constructor(private activatedRoute: ActivatedRoute, private seatMap: SeatMapService, private router: Router, private eventosService: EventosService,
    private dialog: MatDialog, private location: Location, private ticketsService: TicketsService, private auth: AuthenticationService,
    private placesService: PlacesService, private generateMapService: GenerateMapService,
    private apiSalesService: ApiSalesService) {
      this.isSuperAdmin = this.auth.isSuperAdmin();
    }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe({
      next: (params) => {
        if (params.idMap) { this.idMap = params.idMap }
        if (params.idEvent) { this.idEvent = params.idEvent }
        if (location.href.indexOf('edit-event') != -1) {
          this.editEvent = true;
          this.auth.getMyData().subscribe({
            next: (data) => {
              if (data) {
                let organizer = false;
                let organizerEvents = data.organizerEvents?.map(value => value.id);
                if (organizerEvents?.includes(+this.idEvent)) {
                  organizer = true;
                }
                if (!organizer) {
                  this.location.back();
                }
              }
            }
          });
        }
        if (this.fromEvent) {
          this.editEvent = true;
        }
        if (this.idEvent) {
          // this.eventosService.getEventById(this.idEvent).subscribe({
          //   next: (res: any) => {
          //     if (res.data.map_version) {
          //       this.getMapEventBySession(res.data.sessions[0].id);
          //     }
          //   }
          // });
        } else if ((this.fromVenue || this.fromCreate) && this.venue?.id) {
          this.idSpace = this.venue.id;
          this.placesService.getPlaceById(this.venue.id).subscribe({
            next: (res: any) => {
              this.mapSaved = res.data.map;
              this.capacity = res.data.capacity;
              // Solo mostrar el canvas si hay configuración guardada (modo vista)
              // o si venimos en modo edición (fromCreate)
              if (this.fromCreate || this.mapSaved?.configuration) {
                this.loading = false;
              }
              this.emitLoadingState();
            }
          });
        } else {
          this.loading = false;
          this.emitLoadingState();
        }
      }
    });
  }

  getMapEventBySession(sessionId: number, isInitialLoad: boolean = true) {
    this.emitLoadingState();
    this.eventosService.getMapEventBySession(this.idEvent, sessionId).subscribe({
      next: (res: any) => {
        this.mapSaved = res.data;
        this.loading = false;
        // En la carga inicial, generate-canvas pinta el canvas de forma asíncrona y
        // emite `loadCanvas` al terminar (ver paintCanvas), que es quien apaga
        // loadingCanvas. En cambios de sesión posteriores el canvas ya existe: los
        // inputs mapSaved/blockedSeats se aplican de forma síncrona vía ngOnChanges
        // de generate-canvas y `loadCanvas` no se vuelve a emitir, así que hay que
        // apagar el spinner aquí o se quedaría girando indefinidamente.
        if (!isInitialLoad) {
          this.loadingCanvas = false;
        }
        this.emitLoadingState();
      }, error: (err: any) => {
        this.loading = false;
        if (!isInitialLoad) {
          this.loadingCanvas = false;
        }
        this.emitLoadingState();
      }
    })
    // Solo al editar un evento cargamos la info de pedidos por butaca (endpoint admin).
    if (this.fromEvent) {
      this.loadSeatsOrders(sessionId);
    }
  }

  loadSeatsOrders(sessionId: number) {
    this.seatsOrders = {};
    this.loadChannelsMap();
    this.eventosService.getEventSeatsOrders(this.idEvent, sessionId).subscribe({
      next: (res: any) => {
        this.seatsOrders = res?.data || {};
      },
      error: () => {
        this.seatsOrders = {};
      }
    });
  }

  // Canales de venta (id → nombre). Se cachea: solo se pide la primera vez.
  loadChannelsMap() {
    if (Object.keys(this.channelsMap).length > 0) {
      return;
    }
    this.apiSalesService.getAllMethods().subscribe({
      next: (res: any) => {
        const map: { [id: number]: string } = {};
        (res?.data || []).forEach((channel: any) => {
          if (channel?.id != null) {
            map[channel.id] = channel.name;
          }
        });
        this.channelsMap = map;
      },
      error: () => {
        this.channelsMap = {};
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedSession']) {
      this.loadingCanvas = true;
      this.emitLoadingState();
      this.getMapEventBySession(this.selectedSession, changes['selectedSession'].firstChange);
    }
  }

  saveMap() {
    // Validar que todas las secciones de butacas tengan nivel asociado
    const seatSections = this.generateMapService.getSeatSections();
    if (seatSections) {
      const sectionsWithoutLevel = Object.values(seatSections).filter((s: any) =>
        s.section && (s.section.level == null || s.section.level === '')
      );
      if (sectionsWithoutLevel.length > 0) {
        const namesList = sectionsWithoutLevel.map((s: any) => `<b>· ${s.section.name || 'Sin nombre'}</b>`).join('<br>');
        this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: true,
            text: `Las siguientes secciones no tienen nivel asociado:<br><br>${namesList}<br><br>Asigna un nivel a cada sección antes de guardar.`,
            btnCancel: false
          }
        });
        return;
      }
    }

    if (this.fromVenue) {
      this.save.emit(true);
    } else {
      this.seatMap.saveMapEvent(true);
    }
  }

  cancel() {
    if (this.editEvent || this.fromVenue || this.fromCreate) {
      this.location.back();
    } else {
      this.router.navigate(['/profile/seat-maps']);
    }
  }

  paintCanvas(event: any) {
    this.titleMap = event;
    this.loadingCanvas = false;
    this.emitLoadingState();
  }

  editName() {
    const dialogRef = this.dialog.open(NameMapComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: { edit: this.idMap != null, name: this.titleMap }
    });
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result.edit) {
          this.titleMap = result.name;
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.ticketsService.setBookingsStorage(null);
  }

}
